(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["spg-behavior"] && !Shopify.designMode) return;
  try {
    (()=>{
function initSticky(){document.querySelectorAll('[data-spg-sticky-buy]').forEach(bar=>{if(bar.dataset.ready)return;const main=bar.closest('[data-spg-product]')?.querySelector('[data-spg-primary-buy]');if(!main||!('IntersectionObserver' in window))return;bar.dataset.ready='true';new IntersectionObserver(entries=>{const e=entries[0];bar.hidden=e.isIntersecting||e.boundingClientRect.top>0;},{threshold:0}).observe(main);});}
document.addEventListener('click',e=>{if(e.target.closest('[data-spg-print]')){window.print();return;}const link=e.target.closest('a[href]');if(!link)return;let url;try{url=new URL(link.href);}catch{return;}if(!/(^|\.)aliexpress\.com$/.test(url.hostname)&&url.hostname!=='s.click.aliexpress.com')return;if(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()!==true)return;const data={event:'affiliate_click',affiliate_network:'aliexpress',page_path:location.pathname,link_url:url.origin+url.pathname,link_text:link.textContent.trim().slice(0,100),placement:link.closest('[data-spg-placement]')?.dataset.spgPlacement||link.closest('[id^="shopify-section-"]')?.id||'content',product_handle:link.closest('[data-spg-product]')?.dataset.spgProduct||''};window.dataLayer=window.dataLayer||[];window.dataLayer.push(data);document.dispatchEvent(new CustomEvent('spaghettim:affiliate-click',{detail:data}));});
document.addEventListener('shopify:section:load',initSticky);initSticky();
})();
  } catch(e) { console.error(e); }
})();

})();
